(function () {
  'use strict';

  const LABEL_REPLACEMENTS = [
    ['Section de gauche', 'Gauche'],
    ['Section de droite', 'Droite'],
    ['Fraction gauche', 'Fraction'],
    ['Fraction droite', 'Fraction'],
    ['Fraction (Left section)', 'Fraction'],
    ['Fraction (Right section)', 'Fraction'],
  ];

  let formObserver = null;
  let debounceTimer = null;
  let isEnhancing = false;

  function getPricingLookupNoteHtml() {
    const note =
      (window.__customOptionsStrings && window.__customOptionsStrings.pricingLookupNote) ||
      'Entrez la largeur et la hauteur en pouces.';

    return '<p class="measurments-note"><strong>*</strong>' + note + '</p>';
  }

  function insertPricingLookupNote(form) {
    const noteHtml = getPricingLookupNoteHtml();

    form.querySelectorAll('.custom-field__pricing-lookup').forEach(function (el) {
      if (el.dataset.pricingLookupNoteInit) return;

      el.insertAdjacentHTML('beforebegin', noteHtml);
      el.dataset.pricingLookupNoteInit = 'true';
    });
  }

  function setPricingLookupPlaceholders(form) {
    form.querySelectorAll('.custom-field__pricing-lookup input[type="text"]').forEach(function (input) {
      if (input.dataset.pricingLookupPlaceholderInit) return;

      input.placeholder = 'Ex : 36';
      input.dataset.pricingLookupPlaceholderInit = 'true';
    });
  }

  function setPricingLookupSelectFirstOption(form) {
    form.querySelectorAll('.custom-field__pricing-lookup select').forEach(function (select) {
      if (select.dataset.pricingLookupSelectInit) return;

      const firstOption = select.querySelector('option:first-child');
      if (firstOption && firstOption.textContent !== '0') {
        firstOption.textContent = '0';
      }

      select.dataset.pricingLookupSelectInit = 'true';
    });
  }

  function updateCustomFieldLabels(form) {
    form.querySelectorAll('.custom-field__label').forEach(function (el) {
      if (el.dataset.customFieldLabelInit) return;

      let labelText = el.textContent;
      let updated = false;

      LABEL_REPLACEMENTS.forEach(function (replacement) {
        if (labelText.includes(replacement[0])) {
          labelText = labelText.replace(replacement[0], replacement[1]);
          updated = true;
        }
      });

      if (updated) {
        el.textContent = labelText;
      }

      el.dataset.customFieldLabelInit = 'true';
    });
  }

  function enhanceCustomFieldsForm(form) {
    if (!form || isEnhancing) return;

    isEnhancing = true;

    if (formObserver) {
      formObserver.disconnect();
    }

    insertPricingLookupNote(form);
    setPricingLookupPlaceholders(form);
    setPricingLookupSelectFirstOption(form);
    updateCustomFieldLabels(form);

    if (formObserver) {
      formObserver.observe(form, { childList: true, subtree: true });
    }

    isEnhancing = false;
  }

  function scheduleEnhancement(form) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      enhanceCustomFieldsForm(form);
    }, 150);
  }

  function setupFormObserver(form) {
    if (form.dataset.customOptionsInit) return;

    form.dataset.customOptionsInit = 'true';
    enhanceCustomFieldsForm(form);

    formObserver = new MutationObserver(function () {
      scheduleEnhancement(form);
    });

    formObserver.observe(form, { childList: true, subtree: true });
  }

  function init() {
    const root = document.querySelector('product-info') || document.body;
    const existingForm = document.querySelector('.custom-fields-form__form');

    if (existingForm) {
      setupFormObserver(existingForm);
      return;
    }

    let attempts = 0;
    const maxAttempts = 40;

    const waitObserver = new MutationObserver(function () {
      attempts += 1;

      const form = document.querySelector('.custom-fields-form__form');
      if (form) {
        waitObserver.disconnect();
        setupFormObserver(form);
        return;
      }

      if (attempts >= maxAttempts) {
        waitObserver.disconnect();
      }
    });

    waitObserver.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
